import { createSlice } from "@reduxjs/toolkit";

interface MusicLibrariesSlice {
  currentlyPlayingMusicData: any;
  isPlaying: boolean;
  audioRef: any;
}

const initialState: MusicLibrariesSlice = {
  currentlyPlayingMusicData: "",
  isPlaying: false,
  audioRef: null,
};

const musicLibrariesSlice = createSlice({
  name: "musicLibraries",
  initialState,
  reducers: {
    setCurrentlyPlayingMusicData(state, action) {
      state.currentlyPlayingMusicData = action.payload;
    },
    setIsPlaying(state, action) {
      state.isPlaying = action.payload;
    },
    setAudioRef(state, action) {
      state.audioRef = action.payload;
    },
  },
});

export const { setCurrentlyPlayingMusicData, setIsPlaying, setAudioRef } =
  musicLibrariesSlice.actions;

const musicLibrariesReducer = musicLibrariesSlice.reducer;
export default musicLibrariesReducer;
